var transcription=[
  ["š", "s"], ["đ", "dj"], ["ž", "z"], ["č", "c"], ["ć", "c"],
  ["а", "a"], ["б", "b"], ["в", "v"], ["г", "g"], ["д", "d"],
  ["ђ", "dj"], ["е", "e"], ["ж", "z"], ["з", "z"], ["и", "i"],
  ["ј", "j"], ["к", "k"], ["л", "l"], ["љ", "lj"], ["м", "m"],
  ["н", "n"], ["њ", "nj"], ["о", "o"], ["п", "p"], ["р", "r"],
  ["с", "s"], ["т", "t"], ["ћ", "c"], ["у", "u"], ["ф", "f"],
  ["х", "h"], ["ц", "c"], ["ч", "c"], ["џ", "dz"], ["ш", "s"],
];


export default function(source, type) {
  // TODO implement additional slug types
  source=String(source || "").toLowerCase();
  for(var pair of transcription)
    source=source.replaceAll(pair[0], pair[1]);
  source=source.replace(/[^a-z0-9]+/g, "-", source);
  return source;
}
